export class Permissions {
    authenticatable = false;
    constructor(app) {
        if (app && app.auth) {
            this.authenticatable = app.auth;
        }
    }
    getAccountSlug() {
        if (this.authenticatable !== false) {
            return this.authenticatable.account;
        }
        return false;
    }
    isAuthenticated() {
        return this.authenticatable !== false;
    }
    isAuthenticatedWithRole() {
        return this.authenticatable !== false && this.authenticatable.role !== null;
    }
    hasRole(role) {
        if (this.authenticatable !== false) {
            return this.authenticatable.role === role;
        }
        return false;
    }
    isAdmin() {
        return this.hasRole('admin');
    }
    isProgrammeManager() {
        if (this.isAdmin()) {
            return true;
        }
        return this.hasRole('programme_manager');
    }
    isReportUser() {
        if (this.isAdmin()) {
            return true;
        }
        return this.hasRole('report');
    }
    isGuest() {
        return this.hasRole('guest');
    }
}
